// extracted by mini-css-extract-plugin
module.exports = {"container":"OtherReleases_container__214qO","title":"OtherReleases_title__1TwI9","content":"OtherReleases_content__1MzRL","empty":"OtherReleases_empty__iy8qV"};